import * as Sentry from '@sentry/browser';
import isEmpty from 'lodash/fp/isEmpty';

import * as AuthService from 'Services/AuthService';
import { isFetchError } from 'Services/HTTPError';

import { trackUtmSource } from 'dux/tracking/actions';
import { getIsIdle } from 'dux/auth/selectors';
import { fetchAddresses, fetchUser } from 'dux/user/actions';

import {
  AUTH_ERROR,
  AUTH_FAILURE,
  AUTH_REQUEST,
  AUTH_SIGNUP,
  AUTH_SUCCESS,
  USER_SIGNOUT,
} from './actionTypes';

// ----------------------------------------------------------------------------

export const authRequest = () => ({ type: AUTH_REQUEST });
export const authSuccess = () => ({ type: AUTH_SUCCESS });
export const authFailure = () => ({ type: AUTH_FAILURE });
export const authError = () => ({ type: AUTH_ERROR });
export const signupSuccess = () => ({ type: AUTH_SIGNUP });

export const fetchAuth = () => async dispatch => {
  // synchronously define if not authenticated
  if (!AuthService.isCookied()) {
    dispatch(authFailure());
    return;
  }

  dispatch(authRequest());
  try {
    const auth = await AuthService.isAuthenticated();

    if (auth) {
      await Promise.all([dispatch(fetchUser()), dispatch(fetchAddresses())]);

      dispatch(authSuccess());
    } else {
      dispatch(authFailure());
      AuthService.signout();
    }
  } catch (error) {
    if (!isFetchError(error)) {
      Sentry.captureException(error);
      AuthService.signout();
    }

    dispatch(authError());
  }
};

export const fetchAuthIfNeeded = () => (dispatch, getState) => {
  // WARNING this is a hack
  // a token param means the authentication is done with a magic link
  if (typeof window === 'undefined') return;

  const searchParams = new URLSearchParams(window.location.search);

  if (!isEmpty(searchParams?.get('utm_source'))) {
    dispatch(trackUtmSource({ source: searchParams?.get('utm_source') }));
  }

  if (searchParams.get('token')) {
    return;
  }

  // if machine isn't on idle state we can't proceed
  if (!getIsIdle(getState())) {
    return;
  }

  return dispatch(fetchAuth());
};

// ----------------------------------------------------------------------------

export const userSignout = () => ({ type: USER_SIGNOUT });

export const signoutUser = () => dispatch => {
  AuthService.signout();
  dispatch(userSignout());
};
